module.exports = __webpack_public_path__ + "img/font_4.bd11ac1d.webp";